import React, { useEffect, useState } from "react";
import LcLoading from "../../../../components/Generic/LcLoading";
import { SolicitationFilterDashboard } from "../../../../models/SolicitationFilter";
import DashboardFilterService from "../../../../services/DashboardFilter/DashboardFilter";
import "./index.css";
import PivotTableWebix from "../../../../components/Data/Webix";
import SolicitationService from "../../../../services/SolicitationService/SolicitationService";
import * as webix from '@xbs/webix-pro';

interface Props {
	solicitationFilter: SolicitationFilterDashboard,
	typeDetail: number,
	listDetailsLocal: any[],
	open: boolean,
	highLights?: boolean
	clearFiltersPivot: boolean
}

const ListDetails: React.FC<Props> = (props) => {
	const solicitationService = new SolicitationService(props);
	const dashboardFilterService = new DashboardFilterService(props);

	const [columnList, setColumnList] = useState<any[]>([
		// { id: "atualizadoEm", value: "Atualizado em", type: "text" },
		{ id: "mesAtualizadoEm", value: "Mês atualizado em", type: "number" },
		{ id: "anoAtualizadoEm", value: "Ano atualizado em", type: "text" },
		{ id: "solicitacao", value: "Ticket", type: "number" },
		{ id: "solicitacao", value: "Ticket", type: "number" },
		{ id: "vendor", value: "Fornecedor", type: "text" },
		{ id: "origem", value: "Origem", type: "text" },
		{ id: "cliente", value: "Cliente", type: "text" },
		{ id: "grupoServico", value: "Grupo de serviço", type: "text" },
		{ id: "servico", value: "Serviço", type: "text" },
		{ id: "processo", value: "Processo", type: "text" },
		{ id: "tipoProcesso", value: "Tipo de processo", type: "text" },
		{ id: "grupoClassificacao", value: "Grupo de clasificação", type: "text" },
		{ id: "classificacao", value: "Clasificação", type: "text" },
		{ id: "assunto", value: "Assunto", type: "text" },
		{ id: "quemAbriu", value: "Quem abriu", type: "text" },
		{ id: "solicitante", value: "Solicitante", type: "text" },
		{ id: "atendenteInicial", value: "Atendente inicial", type: "text" },
		{ id: "atendenteAtual", value: "Atendente atual", type: "text" },
		{ id: "atendenteFinal", value: "Atendente final", type: "text" },
		{ id: "equipeInicial", value: "Equipe inicial", type: "text" },
		{ id: "equipeAtual", value: "Equipe atual", type: "text" },
		{ id: "equipeFinal", value: "Equipe final", type: "text" },
		{ id: "modoDeAbertura", value: "Modo de abertura", type: "text" },
		{ id: "situacao", value: "Situação", type: "text" },
		{ id: "satisfacao", value: "Satisfação", type: "number" },
		{ id: "tempoTrabalhado", value: "Tempo trabalhado", type: "number" },
		{ id: "tempoTrabalhadoHoras", value: "Tempo trabalhado horas", type: "number" },
		{ id: "tempoTrabalhadoExtra", value: "Tempo trabalhado extra", type: "number" },
		{ id: "tempoPausa", value: "Tempo pausa", type: "number" },
		{ id: "tempoTotal", value: "Tempo total", type: "number" },
		{ id: "tempoEspera", value: "Tempo espera", type: "number" },
		{ id: "tempoSLAResposta", value: "Tempo SLARsp", type: "number" },
		{ id: "tempoSLASolucao", value: "Tempo SLASol", type: "number" },
		{ id: "grupoProcesso", value: "Grupo de processo", type: "text" },
		{ id: "grupoTipoTrabalho", value: "Grupo de tipo de trabalho", type: "text" },
		{ id: "tipoTrabalho", value: "Tipo de trabalho", type: "text" },
		{ id: "diaAberturaSolicitacao", value: "Dia abertura solicitação", type: "text" },
		{ id: "mesAberturaSolicitacao", value: "Mês abertura solicitação", type: "text" },
		{ id: "anoAberturaSolicitacao", value: "Ano abertura solicitação", type: "text" },
		{ id: "diaRegistroSolicitacao", value: "Dia registro solicitação", type: "text" },
		{ id: "mesRegistroSolicitacao", value: "Mês registro solicitação", type: "text" },
		{ id: "anoRegistroSolicitacao", value: "Ano registro solicitação", type: "text" },
		{ id: "dataRegistroSolicitacao", value: "Data registro solicitação", type: "text" },
		{ id: "diaConclusao", value: "Dia conclusão solicitação", type: "text" },
		{ id: "mesConclusao", value: "Mês conclusão solicitação", type: "text" },
		{ id: "anoConclusao", value: "Ano conclusão solicitação", type: "text" },
		{ id: "dataConclusaoSolicitacao", value: "Data conclusão solicitação", type: "text" },
		{ id: "dataEncerramentoSolicitacao", value: "Data encerramento solicitação", type: "text" },
		{ id: "diaCancelamentoSolicitacao", value: "Dia cancelamento solicitação", type: "text" },
		{ id: "mesCancelamentoSolicitacao", value: "Mês cancelamento solicitação", type: "text" },
		{ id: "anoCancelamentoSolicitacao", value: "Ano cancelamento solicitação", type: "text" },
		{ id: "diaRespostaSolicitacao", value: "Dia resposta solicitação", type: "text" },
		{ id: "mesRespostaSolicitacao", value: "Mês resposta solicitação", type: "text" },
		{ id: "anoRespostaSolicitacao", value: "Ano resposta solicitação", type: "text" },
		{ id: "dataVencimentoSLAResposta", value: "Data vencimento SLA resposta", type: "text" },
		{ id: "dataVencimentoSLASolucao", value: "Data vencimento SLA solução", type: "text" },
		{ id: "automacoes", value: "Automações", type: "text" },
		{ id: "criticidade", value: "Criticidade", type: "text" },
		{ id: "abertaSemTrabalhos", value: "Aberta sem trabalhos", type: "text" },
		{ id: "fechadaComTrabalhos", value: "Fechada com trabalhos", type: "text" },
		{ id: "emailSolitante", value: "Email solitante", type: "text" },
		{ id: "estimativaOriginalSolicitacao", value: "Estimativa original solicitacao", type: "text" },
		{ id: "tempoRestanteSolicitacao", value: "Tempo restante solicitacao", type: "text" },
		{ id: "tempoCompletadoSolicitacao", value: "Tempo completado solicitacao", type: "text" },
		{ id: "finalizadoPrimeiroAtendimento", value: "Finaliza no primeiro atendimento", type: "text" },
		{ id: "abertas", value: "Abertas", type: "number" },
		{ id: "abertas", value: "Abertas", type: "number" },
		{ id: "slaRspOK", value: "SlaRspOK", type: "number" },
		{ id: "slaRspNOK", value: "SlaRspNOK", type: "number" },
		{ id: "slaSolOK", value: "SlaSolOK", type: "number" },
		{ id: "slaSolNOK", value: "SlaSolNOK", type: "number" },

		{ id: "awseredComment", value: "Comentário", type: "text" },
		{ id: "total", value: "Total", type: "number" },

		// { id: "sla_ok_teste", value: "% SLA OK", operation: "complex", math: "porcentagem(slaRspOK, abertas)" },
		// { id: "sla_nok_teste", value: "% SLA NOK", operation: "complex", math: "porcentagem(slaRspNOK, abertas)" },
		// { id: "slo_ok_teste", value: "% SLO OK", operation: "complex", math: "porcentagem(slaSolOK, abertas)" },
		// { id: "slo_nok_teste", value: "% SLO NOK", operation: "complex", math: "porcentagem(slaSolNOK, abertas)" },

		// { name: "sla_ok_teste", operation: "complex", math: "porcentagem(slaRspOK, abertas)" },
		// { name: "sla_nok_teste", operation: "complex", math: "porcentagem(slaRspNOK, abertas)" },
		// { name: "slo_ok_teste", operation: "complex", math: "porcentagem(slaSolOK, abertas)" },
		// { name: "slo_nok_teste", operation: "complex", math: "porcentagem(slaSolNOK, abertas)" },
		// { name: "solicitacao", operation: ["count"], format: webix.Number.format },
	]);

	const [listSolicitations, setListSolicitations] = useState<any>([])
	const [loading, setLoading] = useState<boolean>(false);
	const [formattedData, setFormattedData] = useState<any[]>([]);

	const getListDashbord = async () => {
		setLoading(true);

		let filter: SolicitationFilterDashboard = { ...props.solicitationFilter, typeTotalResult: props.typeDetail };

		try {
			const responseList = await dashboardFilterService.GetBIWorkListListByFilter(filter as SolicitationFilterDashboard);
			setListSolicitations(responseList.data);
		}
		catch (erro: any) {
			console.error(erro);
			debugger
		}

		setLoading(false);
	}

	useEffect(() => {
		if (props.listDetailsLocal && props.listDetailsLocal.length > 0) {
			setListSolicitations(props.listDetailsLocal);
		}
		else {
			props.typeDetail !== 0 && getListDashbord();
		}
	}, [props.typeDetail, props.solicitationFilter, props.listDetailsLocal]);

	useEffect(() => {
		if (listSolicitations.length > 0) {
			const formattedData_ = listSolicitations
				.sort((a, b) => { return parseInt(a.id) < parseInt(b.id) ? 1 : -1 })
				.map((item: any) => {
					return {
						// atualizadoEm: item.atualizadoEm ?? "",
						mesAtualizadoEm: item.mesAtualizadoEm ?? "",
						anoAtualizadoEm: item.anoAtualizadoEm ?? "",
						solicitacao: item.solicitacao ?? "",
						vendor: item.vendor ?? "",
						origem: item.origem ?? "",
						cliente: item.cliente ?? "",
						grupoServico: item.grupoServico ?? "",
						servico: item.servico ?? "",
						processo: item.processo ?? "",
						tipoProcesso: item.tipoProcesso ?? "",
						grupoClassificacao: item.grupoClassificacao ?? "Sem grupo de classificação",
						classificacao: item.classificacao ?? "Sem classificação",
						quemAbriu: item.quemAbriu ?? "",
						solicitante: item.solicitante ?? "",
						atendenteInicial: item.atendenteInicial ?? "",
						equipeinicial: item.equipeinicial ?? "",
						equipeAtual: item.equipeAtual ?? "",
						equipeFinal: item.equipeFinal ?? "",
						modoDeAbertura: item.modoDeAbertura ?? "",
						atendente: item.atendente ?? "",
						equipe: item.equipe ?? "",
						satisfacao: item.satisfacao ?? "",
						horasTrabalhadas: item.horasTrabalhadas ?? "",
						situacao: solicitationService.statusList.find(x => x && x.value === item.situacao.toString())?.label ?? "",
						assunto: item.assunto ?? "",
						tempoTrabalhado: item.tempoTrabalhado ?? "",
						tempoTrabalhadoHoras: item.tempoTrabalhadoHoras ?? "",
						tempoEspera: item.tempoEspera ?? "",
						tempoSLAResposta: item.tempoSLAResposta ?? "",
						tempoSLASolucao: item.tempoSLASolucao ?? "",
						grupoProcesso: item.grupoProcesso ?? "",
						grupoTipoTrabalho: item.grupoTipoTrabalho ?? "",
						tipoTrabalho: item.tipoTrabalho ?? "",
						diaRegistroSolicitacao: item.diaRegistroSolicitacao ?? "",
						mesRegistroSolicitacao: item.mesRegistroSolicitacao ?? "",
						anoRegistroSolicitacao: item.anoRegistroSolicitacao ?? "",
						diaAberturaSolicitacao: item.diaAberturaSolicitacao ?? "",
						mesAberturaSolicitacao: item.mesAberturaSolicitacao ?? "",
						anoAberturaSolicitacao: item.anoAberturaSolicitacao ?? "",
						diaConclusao: item.diaConclusao ?? "",
						mesConclusao: item.mesConclusao ?? "",
						anoConclusao: item.anoConclusao ?? "",
						atendenteAtual: item.atendenteAtual ?? "",
						atendenteFinal: item.atendenteFinal ?? "",
						automacoes: item.automacoes ?? "",
						criticidade: item.criticidade ?? "",
						abertaSemTrabalhos: item.abertaSemTrabalhos ?? "",
						fechadaComTrabalhos: item.fechadaComTrabalhos ?? "",
						email: item.email ?? "",
						filial: item.filial ?? "",
						diaCancelamentoSolicitacao: item.diaCancelamentoSolicitacao ?? "",
						mesCancelamentoSolicitacao: item.mesCancelamentoSolicitacao ?? "",
						anoCancelamentoSolicitacao: item.anoCancelamentoSolicitacao ?? "",
						diaRespostaSolicitacao: item.diaRespostaSolicitacao ?? "",
						mesRespostaSolicitacao: item.mesRespostaSolicitacao ?? "",
						anoRespostaSolicitacao: item.anoRespostaSolicitacao ?? "",
						tempoTrabalhadoExtra: item.tempoTrabalhadoExtra ?? "",
						tempoPausa: item.tempoPausa ?? "",
						tempoTotal: item.tempoTotal ?? "",
						tempoTrabalhadoTotal: item.tempoTrabalhadoTotal ?? "",
						emailSolitante: item.emailSolitante ?? "",
						dataVencimentoSLAResposta: item.dataVencimentoSLAResposta ?? "",
						dataVencimentoSLASolucao: item.dataVencimentoSLASolucao ?? "",
						dataRegistroSolicitacao: item.dataRegistroSolicitacao ?? "",
						dataConclusaoSolicitacao: item.dataConclusaoSolicitacao ?? "",
						dataEncerramentoSolicitacao: item.dataEncerramentoSolicitacao ?? "",
						estimativaOriginalSolicitacao: item.estimativaOriginalSolicitacao ?? "",
						tempoRestanteSolicitacao: item.tempoRestanteSolicitacao ?? "",
						tempoCompletadoSolicitacao: item.tempoCompletadoSolicitacao ?? "",
						finalizadoPrimeiroAtendimento: item.finalizadoPrimeiroAtendimento ?? "",
						abertas: item.abertas ?? "",
						slaRspOK: item.slaRspOK ?? "",
						slaRspNOK: item.slaRspNOK ?? "",
						slaSolOK: item.slaSolOK ?? "",
						slaSolNOK: item.slaSolNOK ?? "",
						total: item.total ?? "",
						awseredComment: item.awseredComment ?? "",
					};
				});

			setFormattedData(formattedData_);
		}
	}, [listSolicitations])


	useEffect(() => {
		if (!props.open) {
			setListSolicitations([]);
		}
	}, [props.open])

	const defaultStructure = {
		rows: ["cliente", "equipeAtual", "atendenteAtual", "solicitacao", "awseredComment"],
		filters: [
			{ name: "cliente" },
			{ name: "equipeAtual" },
			{ name: "atendenteAtual" },
			{ name: "solicitacao" },
			{ name: "awseredComment" },
		],
		values: [
			{ name: "satisfacao", operation: "complex", math: "media(satisfacao)" },
			{ name: "solicitacao", operation: ["count"], format: webix.Number.format },
			// { name: "solicitacao", operation: ["count"], format: webix.Number.format },
			{ name: "sla_ok_teste", operation: "complex", math: "porcentagem(slaRspOK, total)" },
			{ name: "slo_ok_teste", operation: "complex", math: "porcentagem(slaSolOK, total)" },
		]
	};

	return (
		<LcLoading loading={loading}>
			<div style={{ maxWidth: "100%", maxHeight: "calc(100% - 78px)" }}>
				{
					formattedData.length > 0 &&
					<PivotTableWebix
						idView={'dataPivot'}
						data={formattedData}
						fields={columnList.sort((a, b) => a.value.localeCompare(b.value, undefined, { sensitivity: 'base' }))}
						mode={"tree"} // table, tree, chart
						chart={{ scale: 'logarithmic', yAxis: { start: 0 } }}
						structure={defaultStructure}
						footer={false}
						clearFiltersPivot={props.clearFiltersPivot}
					/>
				}
			</div>
		</LcLoading>
	);
}

export default ListDetails;